function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Check is item is object
 * @return {Boolean}
 */
export var isObject = function isObject(val) {
  return Object.prototype.toString.call(val) === "[object Object]";
};
/**
 * Check for valid JSON string
 * @param  {String}   str
 * @return {Boolean|Array|Object}
 */

export var isJson = function isJson(str) {
  var t = !1;

  try {
    t = JSON.parse(str);
  } catch (e) {
    return !1;
  }

  return !(null === t || !Array.isArray(t) && !isObject(t)) && t;
};
/**
 * Create DOM element node
 * @param  {String}   nodeName nodeName
 * @param  {Object}   attrs properties and attributes
 * @return {Object}
 */

export var createElement = function createElement(nodeName, attrs) {
  var dom = document.createElement(nodeName);

  if (attrs && "object" == _typeof(attrs)) {
    for (var attr in attrs) {
      if ("html" === attr) {
        dom.innerHTML = attrs[attr];
      } else {
        dom.setAttribute(attr, attrs[attr]);
      }
    }
  }

  return dom;
};
export var flush = function flush(el) {
  if (el instanceof NodeList) {
    el.forEach(function (e) {
      return flush(e);
    });
  } else {
    el.innerHTML = "";
  }
};
/**
 * Create button helper
 * @param  {String}   class
 * @param  {Number}   page
 * @param  {String}   text
 * @return {Object}
 */

export var button = function button(className, page, text) {
  return createElement("li", {
    class: className,
    html: "<a href=\"#\" data-page=\"".concat(page, "\">").concat(text, "</a>")
  });
};
/**
 * Bubble sort algorithm
 */

export var sortItems = function sortItems(a, b) {
  var c;
  var d;

  if (1 === b) {
    c = 0;
    d = a.length;
  } else {
    if (b === -1) {
      c = a.length - 1;
      d = -1;
    }
  }

  for (var e = !0; e;) {
    e = !1;

    for (var f = c; f != d; f += b) {
      if (a[f + b] && a[f].value > a[f + b].value) {
        var g = a[f];
        var h = a[f + b];
        var i = g;
        a[f] = h;
        a[f + b] = i;
        e = !0;
      }
    }
  }

  return a;
};
/**
 * Pager truncation algorithm
 */

export var truncate = function truncate(a, b, c, d, ellipsis) {
  d = d || 2;
  var j;
  var e = 2 * d;
  var f = b - d;
  var g = b + d;
  var h = [];
  var i = [];

  if (b < 4 - d + e) {
    g = 3 + e;
  } else if (b > c - (3 - d + e)) {
    f = c - (2 + e);
  }

  for (var k = 1; k <= c; k++) {
    if (1 == k || k == c || k >= f && k <= g) {
      var l = a[k - 1];
      l.classList.remove("active");
      h.push(l);
    }
  }

  h.forEach(function (c) {
    var d = c.children[0].getAttribute("data-page");

    if (j) {
      var _e = j.children[0].getAttribute("data-page");

      if (d - _e == 2) i.push(a[_e]);else if (d - _e != 1) {
        var _f = createElement("li", {
          class: "ellipsis",
          html: "<a href=\"#\">".concat(ellipsis, "</a>")
        });

        i.push(_f);
      }
    }

    i.push(c);
    j = c;
  });
  return i;
};